<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <circle cx="9" cy="9" r="8.5" :stroke="color" />
      <path
        :stroke="color"
        d="M5.818 12.544C6.37 15.47 7.588 17.5 9 17.5c1.409 0 2.623-2.021 3.178-4.935m.026-6.994C11.66 2.585 10.43.5 9 .5 7.581.5 6.36 2.55 5.81 5.498"
      />
      <path :fill="color" d="M1 5H17V6H1zM1 12H17V13H1z" />
      <path
        :fill="color"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12.5 7.5L14.5 9 12.5 10.5z"
      />
      <rect width="10" height="2" x="3" y="8" :fill="color" rx=".5" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
